// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"faq-accordion_sectionTitle__EK0nN","faqSection":"faq-accordion_faqSection__h1QEr"};